import { __assign, __extends } from "tslib";
import Element from './base';
import SizeController from './controller/size';
import IntervalShapeFactory from './shape/interval';
var Interval = /** @class */ (function (_super) {
    __extends(Interval, _super);
    function Interval(cfg) {
        var _this = _super.call(this, __assign({ type: 'interval', shapeType: 'interval', generatePoints: true }, cfg)) || this;
        // 初始化 sizeController
        var sizeController = new SizeController(_this);
        _this.set('sizeController', sizeController);
        // 设置 IntervalShapeFactory
        _this.set('shapeFactory', IntervalShapeFactory);
        return _this;
    }
    Interval.prototype.createShapePointsCfg = function (obj) {
        var cfg = _super.prototype.createShapePointsCfg.call(this, obj);
        cfg.size = this.getNormalizedSize(obj); // 获取每条数据对应的 size 归一化后的值
        return cfg;
    };
    Interval.prototype.isShareTooltip = function () {
        var isShareTooltip = this.get('shareTooltip');
        var coord = this.get('coord');
        var coordType = coord.type;
        if (coordType === 'theta' || (coordType === 'polar' && coord.isTransposed)) {
            isShareTooltip = false; // 饼图不合并
        }
        return isShareTooltip;
    };
    return Interval;
}(Element));
export default Interval;
//# sourceMappingURL=interval.js.map